// extracted by mini-css-extract-plugin
module.exports = {"rotation":"RivenditoreCard_rotation__y_H3O"};